import React, { useState, useEffect, useContext } from 'react'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { toast } from 'react-toastify'
import { Store } from '../../Utils/Store'
import './AdminStyles.css'

const Login = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { state, dispatch } = useContext(Store)
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  const [loading, setLoading] = useState(false)

  // Check if already logged in
  useEffect(() => {
    if (state.Admin) {
      // Already logged in, redirect to admin dashboard
      const redirectTo = location.state?.from?.pathname || '/admin'
      navigate(redirectTo, { replace: true })
    }
  }, [navigate, location, state.Admin])

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      // Get admin users from localStorage
      const adminUsers = JSON.parse(localStorage.getItem('admin_users') || '[]')
      
      // Find matching user
      const user = adminUsers.find(
        u => u.email === formData.email && u.password === formData.password
      )

      if (user) {
        // Login successful
        const adminData = {
          id: user.id || Date.now(),
          email: user.email,
          loginTime: new Date().toISOString()
        }
        
        dispatch({ type: 'AdminLogin', payload: adminData })
        toast.success('Login successful!')
        
        // Redirect to admin dashboard
        const redirectTo = location.state?.from?.pathname || '/admin'
        navigate(redirectTo, { replace: true })
      } else {
        toast.error('Invalid email or password')
      }
    } catch (error) {
      console.error('Login error:', error)
      toast.error('Login failed. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="admin-wrapper">
      <Helmet>
        <title>Admin Login - KD General Transport LLC</title>
      </Helmet>
      <div className="admin-login-wrapper">
        <div className="admin-login-container">
          <div className="admin-login-header">
            <h1 className="admin-login-title">
              Admin Login
            </h1>
            <p className="admin-login-subtitle">
              KD General Transport Admin Panel
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="admin-form-group">
              <label className="admin-form-label">
                Email Address
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                placeholder="admin@admin.com"
                className="admin-form-input"
              />
            </div>

            <div className="admin-form-group">
              <label className="admin-form-label">
                Password
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                required
                placeholder="Enter your password"
                className="admin-form-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="admin-btn admin-btn-primary"
              style={{ width: '100%', padding: '14px', fontSize: '16px' }}
            >
              {loading ? (
                <span>
                  <i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                  Logging in...
                </span>
              ) : (
                <span>
                  <i className="fa fa-sign-in" style={{ marginRight: '8px' }}></i>
                  Login
                </span>
              )}
            </button>
          </form>

          <div style={{ 
            marginTop: '30px', 
            paddingTop: '20px', 
            borderTop: '1px solid #e0e0e0',
            textAlign: 'center'
          }}>
            <Link 
              to="/" 
              style={{ 
                color: '#007bff', 
                textDecoration: 'none',
                fontSize: '14px'
              }}
            >
              <i className="fa fa-arrow-left" style={{ marginRight: '5px' }}></i>
              Back to Website
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
